import { Breadcrumb } from "@refinedev/mui";
import { Box } from "@mui/material";
import PageHeading from "../../components/pageHeading";
export const CYRCSTEMComputersChildrenEnrolledInCYRCs = () => {
  return (
    <Box>
      <Breadcrumb />
      <PageHeading heading="Children enrolled in CYRCs" />
    </Box>
  );
};
